module.exports = "./assets/assets/相关政策依据.c2c91d45.docx";